import { useEffect, useState } from 'react';
import { ArrowLeftRight, InfoCircle, PlusCircle, Search, ThreeDotsVertical } from 'react-bootstrap-icons';
import { SubmitHandler, useForm } from 'react-hook-form';
import FormButton from '../../../Components/Buttons/FormButton';
import FormSelect from '../../../Components/FormTag/FormSelect';
import InputFiled from '../../../Components/FormTag/InputFiled';
import Table, { Column } from '../../../Components/Tables/Table';
import CommonTooltipComponent from '../../../Components/Tooltip/CommonTooltipComponent';
import { InventoryStatusOptions, replenishmentCreateData } from '../../../Data/replenishmentData';
import PageHeader from '../../../Layout/PageHeader';
import { replenishmentCreate } from './ReplenishmentCreate.type';
import { useNavigate } from 'react-router-dom';
import TimerWithPausePlay from '../../../Layout/Timer';
import CommonConfirmationModal from '../../../Components/Modals/CommonConfirmationModal';


const ReplenishmentCreate = () => {
  const navigate = useNavigate();
  const [replenishmentData, setReplenishmentData] = useState(replenishmentCreateData);
  // Add state for form validity
  const [isButtonActive, setIsButtonActive] = useState(false);
  
  const handleExit = () => {
    console.log("Exiting timer...");}

    const [showconfModal, setShowconfModal] = useState(false);
    const handleconfShow = () => setShowconfModal(true);
    const handleconfClose = () => setShowconfModal(false);
    const onModalSubmit = (response: boolean) => {
      console.log(response);
      handleconfClose();
    };
    const handelDeleteAction = (data: any) => {
      setShowconfModal(true);
    };
    const [showRowClicked, setShowRowClicked] = useState(false);


  const backNavigate = () => {
    return navigate(`/inventory/replenishment`);
  }

  const handleClose = () => {
    backNavigate();
  }

  const save = () => {
    backNavigate();
  }

  const handleAutoRunChange = (index: number) => {
    const updatedData = [...replenishmentData];
    updatedData[index].autoRun = !updatedData[index].autoRun;
    setReplenishmentData(updatedData);
  };
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<replenishmentCreate>({
    defaultValues: new replenishmentCreate(),
  });

 
  const handleCreateReplenishment: SubmitHandler<replenishmentCreate> = (data) => {
    replenishmentCreateData.push({ ...data, autoRun: true });
    setReplenishmentData([...replenishmentData, data]);
  }
 
  const name = watch('name');
  const fromInventoryStatus = watch('fromInventoryStatus');
  const toInventoryStatus = watch('toInventoryStatus');
  const maxLinesOrTransfer = watch('maxLinesOrTransfer'); useEffect(() => {
    if (
      name.trim() &&
      fromInventoryStatus.trim() &&
      toInventoryStatus.trim() &&
      maxLinesOrTransfer >= 0
    ) {
      setIsButtonActive(true);
    } else {
      setIsButtonActive(false);
    }
  }, [name, fromInventoryStatus, toInventoryStatus, maxLinesOrTransfer]);


  const columns: Column[] = [
    {
      name: "Name",
      selector: (row: { name: string }) => row.name,
    },
    {
      name: "From Inventory Status ",
      selector: (row: { fromInventoryStatus: string }) => row.fromInventoryStatus,
    },
    {
      name: "To Inventory Status",
      selector: (row: { toInventoryStatus: string }) => row.toInventoryStatus,
    },
    {
      name: "Max Lines / Transfer",
      selector: (row: { maxLinesOrTransfer: number }) => row.maxLinesOrTransfer,
    },
    {
      name: "Autorun",
      selector: (row, index) => (
        <div className=" w-100">

          <div className="form-check form-switch sidebar-toggler d-flex align-items-center gap-2 ">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`flexSwitchCheckChecked-${index ?? 0}`}
              style={{ height: '22px', width: '36px' }}
              checked={row.autoRun}
              onChange={() => index !== undefined && handleAutoRunChange(index)}  
            />
            <div className="mt-1">
              <CommonTooltipComponent content="If enabled system automatically checks for items below min. stock level after a 15 mins interval." icon=<InfoCircle /> positionOfToolTop='bottom' customClassName="custom-tooltip" />
            </div>
          </div>
        </div>

      ),
    },
    {
      name: "Execute",
      selector: (row) => (
        <div
          className={`${row.autoRun ? "button-disabled" : "bg-info"} rounded-pill text-center cursor-pointer`}
          style={{ height: "30px", width: "64px" }}
        >
          <p className="text-white pt-1">Run</p>
        </div>
      ),
    },
    {
      name: (
        <>
          <ArrowLeftRight className='me-2' style={{ stroke: 'black', strokeWidth: 1 }} />
          <PlusCircle style={{ stroke: 'black', strokeWidth: 1 }} />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowRowClicked(true)}
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold">
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDeleteAction(row)}
            >
              Delete
            </li>
          </ul>

        </>
      ),
      enableSorting: false,  
    },
  ]

  return (
    <>

      <PageHeader viewType={true} gridUrl='/inventory/replenishment'/>
      <h5 className="text-start mt-1 mb-3">Replenishment</h5>
      <div className="mt-2 bg-white rounded py-4 d-flex flex-column">
        <div className="row mx-0 px-0">
          <div className="col-10 px-0">
            <div className="row mb-4 mx-0 px-0 d-flex align-items-center">
              <div className="col-6">
                <div className="px-2">
                  <label className="fw-medium">Name *</label>
                  <div className="mt-1">
                    <InputFiled
                      type="text"
                      tabIndex={1}
                      register={register}
                      name="name"
                      required={true}
                      errors={errors.name}
                      className="form-control"
                      placeholder="Enter"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="px-2">
                  <label className="fw-medium">From Inventory Status *</label>
                  {/* <Select components={{ Placeholder: CustomPlaceholder }} options={InventoryStatusOptions} /> */}
                  <FormSelect
                    name="fromInventoryStatus"
                    tabIndex={2}
                    control={control}
                    optionList={InventoryStatusOptions}
                    required={true}
                    className="form-control p-0 mt-1"
                    placeholder={<div style={{ display: 'flex', alignItems: 'center' }}>
                      <Search style={{ marginRight: '5px' }} />
                      Search
                    </div>}
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>

            <div className="row mx-0 px-0 d-flex align-items-center">
              <div className="col-6">
                <div className="px-2">
                  <label className="fw-medium">To Inventory Status *</label>
                  <FormSelect
                    name="toInventoryStatus"
                    tabIndex={3}
                    control={control}
                    required={true}
                    optionList={InventoryStatusOptions}
                    className="form-control p-0 mt-1"
                    placeholder={<div style={{ display: 'flex', alignItems: 'center' }}>
                      <Search style={{ marginRight: '5px' }} />
                      Search
                    </div>}
                    isSearchable={true}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="px-2">
                  <label className="fw-medium">Max Lines / Transfer *</label>
                  <div className="mt-1">
                    <InputFiled
                      type="text"
                      tabIndex={4}
                      register={register}
                      required={true}
                      name="maxLinesOrTransfer"
                      errors={errors.maxLinesOrTransfer}
                      className="form-control"
                      placeholder="Enter"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="col-2 mx-auto my-auto">
            <div className="px-2">
              <FormButton
                className={`${isButtonActive ? 'sph-btn me-4 ' : 'button-disabled sph-btn me-4 text-white'}`}
                handleClick={handleSubmit(handleCreateReplenishment)}
                disabled={!isButtonActive}
              >
                Create
              </FormButton>
            </div>
          </div>
        </div>

      </div>
      <div className="mt-2 bg-white rounded py-4 px-3">
        <Table isStripped={true} customClassName='transferDetailsTable' data={replenishmentCreateData} columns={columns} CheckboxStatus={false} />
      </div>


      <div className='row'>
      <div className='col-12 d-flex mt-2'>
      {/* <TimerWithPausePlay timeInMinutes={4} onExit={handleExit} />  */}
      {/*to pass custom timing*/}
      {/* <TimerWithPausePlay/> */}                                  
      {/*to pass default timing*/} 
      <div className="mt-2 bg-white rounded py-3 mt-auto col">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleClose()}>
            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}>
            Cancel
          </FormButton>
        </div>
      </div>
      </div>
      </div>

      <CommonConfirmationModal
        show={showconfModal}
        content={<> You are about to delete this  <br />
        Are you Sure? </>}
        confirmBtnText="Yes"
        cancelBtnText="No"
        onModalSubmit={onModalSubmit}
      />
    </>
  );
};

export default ReplenishmentCreate;
